if (typeof ReadTime == 'undefined') {
  class ReadTime extends HTMLElement {
    constructor() {
      super();

      this.innerHTML = 'Calculating read time...';

      if (document.body.className.includes('template-article')) {
        this.calculateReadTime(document);
      } else {
        let currentCard = this.closest('.article-card');
        let url = currentCard.querySelector('.card__heading a').href;

        this.getArticlePage(url).then(resp => {
          this.calculateReadTime(this.articleDocument);
        });
      }
    }
    
    calculateReadTime(doc) {
      let text = doc.querySelector('.article-template__content').innerText;
      const wpm = 225;
      const words = text.trim().split(/\s+/).length;
      console.log(words);
      const time = Math.ceil(words / wpm);
      this.innerText = `${time} min read`;
    }

    async getArticlePage(url) {
      const response = await fetch(url);
      const text = await response.text();

      let articleDocument = document.createElement('div');
      articleDocument.innerHTML = text;
      
      this.articleDocument = articleDocument;
    }
  }
  
  customElements.define('read-time', ReadTime);
}